import MainLayout from '../layouts/MainLayout.vue';
// eslint-disable-next-line import/no-cycle
import store from '../store';

const Grades = () => import('../views/Main/Grades.vue');
const Attendances = () => import('../views/Main/Attendances.vue');
const Homeworks = () => import('../views/Main/Homeworks.vue');
const OnlineMaterials = () => import('../views/Main/OnlineMaterials.vue');
const ChangePassword = () => import('../views/Main/ChangePassword.vue');
const PaymentReturn = () => import('../views/Main/PaymentReturn.vue');
const Declarations = () => import('../views/Main/Declarations.vue');

export default {
  path: '/dziecko/',
  name: 'Main',
  component: MainLayout,
  redirect: '/dziecko/prace-domowe',
  beforeEnter(to, from, next) {
    if (store.getters['auth/isLogged']) {
      next();
    } else {
      next({ name: 'Auth.Login', query: { redirect: to.fullPath, id: to?.query?.id } });
    }
  },
  children: [
    {
      path: 'oceny',
      name: 'Main.Grades',
      component: Grades,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (store.getters['auth/isDemoAccess']) {
          next({ name: 'Main.OnlineMaterials' });
        } else {
          next();
        }
      },
    },
    {
      path: 'obecnosci',
      name: 'Main.Attendances',
      component: Attendances,
      meta: {
        background: 'blue-light-main',
      },
      async beforeEnter(to, from, next) {
        if (store.getters['auth/isDemoAccess']) {
          next({ name: 'Main.OnlineMaterials' });
        } else {
          next();
        }
      },
    },
    {
      path: 'prace-domowe',
      name: 'Main.Homeworks',
      component: Homeworks,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (store.getters['auth/isDemoAccess']) {
          next({ name: 'Main.OnlineMaterials' });
        } else {
          next();
        }
      },
    },
    {
      path: 'materialy-online',
      name: 'Main.OnlineMaterials',
      component: OnlineMaterials,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (!store.getters['auth/isProfileSelected']) {
          next({ name: 'Auth.Welcome' });
        } else {
          next();
        }
      },
    },
    {
      path: 'zmien-haslo',
      name: 'Main.ChangePassword',
      component: ChangePassword,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (store.getters['auth/isLogged']) {
          next();
        } else {
          next({ name: 'Auth.Login' });
        }
      },
    },
    {
      path: 'dane-do-zwrotow',
      name: 'Main.PaymentReturn',
      component: PaymentReturn,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (store.getters['auth/isLogged']) {
          next();
        } else {
          next({ name: 'Auth.Login' });
        }
      },
    },
    {
      path: 'deklaruj',
      name: 'Main.Declarations',
      component: Declarations,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter(to, from, next) {
        if (store.getters['auth/isLogged']) {
          next();
        } else {
          next({ name: 'Auth.Login' });
        }
      },
    },
  ],
};
